<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-button variant="primary" @click="$router.push('/admin/contacts/toevoegen')" class="pull-right">Contactpersoon toevoegen</b-button>
                    </b-col>
                </b-row>
                <resource-index header="Contactpersonen" endpoint="contacts" show-route="contacts.view"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'contacts',
        components: {ResourceIndex},
        computed: {
            userRole () {
                return this.$store.state.userRole
            }
        },
    }
</script>
